/* ec-sec-cart-drawer.js — externalized static JS for sections/cart-drawer.liquid (config via window.ECSQ queue) */
(function() {
  if (window.__ecAsset_cart_drawer) return;
  window.__ecAsset_cart_drawer = 1;
  function initSection(sectionId, cfg) {
  var drawer, overlay, closeBtn, loading, body;
  var i18n = cfg.i18n || {};
  function init() {
    drawer = document.getElementById('ec-cart-drawer'); overlay = document.getElementById('ec-cart-overlay');
    closeBtn = document.getElementById('ec-cart-close'); loading = document.getElementById('ec-cart-loading');
    body = document.getElementById('ec-cart-body');
    if (!drawer) return;
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (window.__ecCdKeydown) document.removeEventListener('keydown', window.__ecCdKeydown);
    window.__ecCdKeydown = function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    };
    document.addEventListener('keydown', window.__ecCdKeydown);
    if (window.__ecCdDocClick) document.removeEventListener('click', window.__ecCdDocClick);
    window.__ecCdDocClick = function(e) {
      var cartLink = e.target.closest('[data-ec-open-cart], a[href$="/cart"]');
      if (cartLink && !cartLink.closest('.ec-cd') && !cartLink.closest('.ec-cd__checkout')) {
        e.preventDefault(); refreshDrawer(); openDrawer();
      }
    };
    document.addEventListener('click', window.__ecCdDocClick);
    function bindCartEvents() {
      if (typeof EC !== 'undefined' && EC.on) {
        EC.on('cart:added', function() {
          refreshDrawer(); openDrawer();
        });
        /* stok siniri vb: kullaniciya NEDENINI soyle, state'i tazele (onceden sessizce yutuluyordu) */
        EC.on('cart:change-error', function(err) {
          showCartMsg((err && err.message) || 'Could not update the cart.');
        });
      } else {
        setTimeout(bindCartEvents, 50);
      }
    } bindCartEvents(); bindItemButtons(); loadUpsell();
  }
  function openDrawer() {
    if (!drawer) return; drawer.classList.add('is-open'); overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    if (typeof EC !== 'undefined' && EC.trapFocus) EC.trapFocus(drawer);
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return; drawer.classList.remove('is-open'); overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    if (typeof EC !== 'undefined' && EC.releaseFocus) EC.releaseFocus();
  }
  function showLoading() { if (loading) loading.classList.add('is-active'); }
  function hideLoading() { if (loading) loading.classList.remove('is-active'); }
  /* drawer ust kismina gecici bilgi/uyari seridi (stok siniri, ag hatasi) */
  function showCartMsg(text) {
    if (!body) return;
    var el = document.getElementById('ec-cd-flash');
    if (!el) {
      el = document.createElement('p');
      el.id = 'ec-cd-flash';
      el.setAttribute('role', 'status');
      el.style.cssText = 'margin:0 0 var(--ec-sp-12);padding:var(--ec-sp-8) var(--ec-sp-12);border:var(--ec-bw) solid var(--ec-hairline);border-radius:var(--ec-radius-sm);background:var(--ec-paper);color:var(--ec-ink);font-family:var(--ec-font-mono);font-size:var(--ec-fs-micro);';
      body.insertBefore(el, body.firstChild);
    }
    el.textContent = text;
    clearTimeout(el.__t); el.__t = setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 5000);
  }
  function refreshDrawer() {
    if (!drawer) return; showLoading();
    var sectionEl = drawer.closest('[id^="shopify-section"]');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : 'ec-cart-drawer'; fetch('/?section_id=' + sectionId)
      .then(function(r) { return r.text(); }) .then(function(html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var nb = tmp.querySelector('#ec-cart-body');
        var nf = tmp.querySelector('#ec-cart-footer');
        var nc = tmp.querySelector('[data-ec-cart-count]');
        if (nb && body) body.innerHTML = nb.innerHTML;
        var f = document.getElementById('ec-cart-footer');
        if (nf && f) f.outerHTML = nf.outerHTML;
        else if (nf && !f) {
          var ref = document.getElementById('ec-cart-body');
          if (ref) ref.insertAdjacentHTML('afterend', nf.outerHTML);
        }
        else if (!nf && f) f.remove();
        if (nc) {
          document.querySelectorAll('[data-ec-cart-count], .ec-cart-count').forEach(function(el) {
            el.textContent = nc.textContent; el.style.display = parseInt(nc.textContent) > 0 ? 'flex' : 'none';
          });
        } hideLoading(); bindItemButtons(); loadUpsell(); setCheckoutDiscount(); restoreDiscountUI(); annotateSizes();
        /* yeni HTML'deki data-ec-cents'leri hemen cevir — FX'in kor timer'ini bekleme */
        if (window.ECFX && window.ECFX.active && window.ECFX.apply) { try { window.ECFX.apply(); } catch (e) {} }
      }) .catch(function() { hideLoading(); showCartMsg('Connection hiccup — pull to refresh or try again.'); });
  }
  /* footer yenilenince uygulanan indirim kodunu input+mesajda geri goster (siliniyordu) */
  function restoreDiscountUI() {
    if (!window.__ecDiscount) return;
    var input = document.getElementById('ec-discount-input');
    var msg = document.getElementById('ec-discount-msg');
    if (input && !input.value) input.value = window.__ecDiscount;
    if (msg && !msg.textContent) { msg.textContent = i18n.discountPending || 'Applied at checkout'; msg.className = 'ec-cd__discount-msg is-neutral'; }
  }
  /* PDP'de secilen bolgesel bedeni (US/UK) sepette EU'nun yanina yaz — "US 8.5-9 sectim, sepette 39" karisikligini onler */
  function annotateSizes() {
    if (!window.ECSizeMap || !window.ECRegion) return;
    document.querySelectorAll('.ec-cd__item').forEach(function(it) {
      var v = it.querySelector('.ec-cd__item-variant');
      if (!v || v.getAttribute('data-ec-annotated')) return;
      var t = it.querySelector('.ec-cd__item-title');
      var g = t && /for men/i.test(t.textContent) ? 'men' : 'women';
      /* 05.08: ECRegion 'aunz' isaretcisi olabilir (AU/NZ kadin US, erkek UK okur).
         Cozumu ec-size-map yapar; ham deger haritada anahtar degil, sessizce duserdi. */
      var reg = window.ECEffRegion ? window.ECEffRegion(g) : window.ECRegion;
      if (reg === 'eu') return;
      var m = v.textContent.match(/(?:^|\/\s*)(3[5-9]|4[0-7])\s*$/);
      if (!m) return;
      var rng = window.ECSizeMap[g] && window.ECSizeMap[g][m[1]];
      if (!rng || !rng[reg]) return;
      v.textContent = v.textContent + ' (' + reg.toUpperCase() + ' ' + rng[reg] + ')';
      v.setAttribute('data-ec-annotated', '1');
    });
  }
  /* Uygulanan indirim kodunu checkout linkine tasi (footer yenilense de kaybolmaz) */
  function setCheckoutDiscount() {
    if (!window.__ecDiscount) return;
    var co = document.getElementById('ec-cart-checkout');
    if (co) co.href = '/checkout?discount=' + encodeURIComponent(window.__ecDiscount);
  }
  function bindItemButtons() {
    if (!body) return; body.querySelectorAll('.ec-cd__qty-btn, .ec-cd__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (typeof EC === 'undefined' || !EC.cart) return;
        showLoading();
        /* 31.07 — birlesik satir: BXGY ayni varyanti birden cok satira bolebiliyor
           ve HER mutasyonda key'ler degisiyor (olculdu). REMOVE bu yuzden key listesi
           degil varyant kimligiyle calisir: her adimda taze sepeti ceker, o varyantin
           ilk satirini siler, kalmayana kadar tekrarlar (bayat key kalintisi birakmaz). */
        var vid = this.dataset.vid;
        if (vid && this.classList.contains('ec-cd__remove')) {
          var step = function(guard) {
            if (guard <= 0) { refreshDrawer(); return; }
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
              var line = (c.items || []).filter(function(i) { return String(i.variant_id) === vid; })[0];
              if (!line) { refreshDrawer(); return; }
              EC.cart.change(line.key, 0).then(function() { step(guard - 1); }).catch(function() { refreshDrawer(); });
            }).catch(function() { refreshDrawer(); });
          };
          step(10);
          return;
        }
        /* +/- de vid uzerinden: taze sepetten ilk kurucu satiri bul, ±1 uygula —
           render'daki key her an bayatlayabiliyor (her mutasyonda degisiyor) */
        var act = this.dataset.action;
        if (vid && (act === 'increase' || act === 'decrease')) {
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
            var line = (c.items || []).filter(function(i) { return String(i.variant_id) === vid; })[0];
            if (!line) { refreshDrawer(); return; }
            var next = act === 'increase' ? line.quantity + 1 : line.quantity - 1;
            EC.cart.change(line.key, next).then(refreshDrawer).catch(function() { refreshDrawer(); });
          }).catch(function() { refreshDrawer(); });
          return;
        }
        var key = this.dataset.key;
        var qty = parseInt(this.dataset.qty, 10);
        EC.cart.change(key, qty).then(refreshDrawer).catch(function() { refreshDrawer(); });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Siparis notu: keepalive ile kaydet + checkout'a gidilirken bekleyen notu FLUSH et (not kaybi bug'i) */
  var noteTimer, notePending = null;
  function saveNote(val) {
    notePending = null;
    fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({note: val}), keepalive: true });
  }
  document.addEventListener('change', function(e) {
    if (e.target.id === 'ec-cart-note') {
      notePending = e.target.value;
      clearTimeout(noteTimer); noteTimer = setTimeout(function() { saveNote(notePending); }, 500);
    }
  });
  document.addEventListener('click', function(e) {
    var co = e.target.closest && e.target.closest('#ec-cart-checkout, a[href^="/checkout"]');
    if (!co) return;
    var noteEl = document.getElementById('ec-cart-note');
    var val = notePending !== null ? notePending : (noteEl && noteEl === document.activeElement ? noteEl.value : null);
    if (val !== null) { clearTimeout(noteTimer); saveNote(val); }
  }, true);
  /* Discount: document-level delegation — footer outerHTML ile yenilenince binding olmesin (onceden ilk refresh'te oluyordu) */
  function applyDiscount() {
    var input = document.getElementById('ec-discount-input');
    var msg = document.getElementById('ec-discount-msg');
    var code = input ? input.value.trim() : '';
    if (!code || !msg) return;
    msg.textContent = ''; msg.className = 'ec-cd__discount-msg';
    fetch('/discount/' + encodeURIComponent(code)).then(function() {
      window.__ecDiscount = code;
      setCheckoutDiscount();
      msg.textContent = i18n.discountPending; msg.className = 'ec-cd__discount-msg is-neutral';
      setTimeout(function() { refreshDrawer(); }, 800);
    });
  }
  document.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'ec-discount-btn') applyDiscount();
  });
  document.addEventListener('keydown', function(e) {
    if (e.target && e.target.id === 'ec-discount-input' && e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', annotateSizes); } else { annotateSizes(); }
  function fmtMoney(cents) {
    try {
      if (window.ECFX && window.ECFX.active) { try { return window.ECFX.fmt(cents); } catch (e2) {} }
      return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function loadUpsell() {
    var wrap = document.getElementById('ec-cart-upsell');
    if (!wrap) return;
    var items = document.querySelectorAll('.ec-cd__item');
    if (!items.length) { wrap.innerHTML = ''; return; }
    var pid = items[0].getAttribute('data-product-id');
    if (!pid) return;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=2&intent=related') .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || !data.products.length) return;
        var html = '<p class="ec-cd__upsell-title">' + escHtml(i18n.youMayAlsoLike) + '</p>'; data.products.slice(0, 2).forEach(function(p) {
          var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[^.]+)$/, '_100x$1') : '';
          var vid = p.variants[0] ? p.variants[0].id : ''; html += '<div class="ec-cd__upsell-item">'
            + (img ? '<img src="' + img + '" alt="' + escHtml(p.title) + '" class="ec-cd__upsell-img" width="50" height="50" loading="lazy">' : '')
            + '<div class="ec-cd__upsell-info"><div class="ec-cd__upsell-name">' + escHtml(p.title) + '</div>'
            + '<div class="ec-cd__upsell-price" data-ec-cents="' + p.variants[0].price + '">' + fmtMoney(p.variants[0].price) + '</div></div>'
            + '<button class="ec-cd__upsell-add" data-vid="' + vid + '" aria-label="Add to cart">+</button></div>';
        }); wrap.innerHTML = html; wrap.querySelectorAll('.ec-cd__upsell-add').forEach(function(btn) {
          btn.addEventListener('click', function() {
            if (typeof EC !== 'undefined' && EC.cart) {
              EC.cart.add(btn.dataset.vid, 1).then(function() { refreshDrawer(); }).catch(function() { refreshDrawer(); });
            }
          });
        });
      })
      .catch(function() {});
  }
  }
  function ecDrainQueue() {
    var q = window.ECSQ = window.ECSQ || [];
    var mine = [];
    window.ECSQ = q.filter(function(entry) {
      if (entry && entry[0] === 'cart-drawer') { mine.push(entry); return false; }
      return true;
    });
    mine.forEach(function(entry) { initSection(entry[1], entry[2] || {}); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ecDrainQueue);
  } else {
    ecDrainQueue();
  }
  document.addEventListener('shopify:section:load', function() { ecDrainQueue(); });
})();
